module.exports = __webpack_public_path__ + "static/img/background-forest-blue.a4d72c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background-forest-blue.jpg
// module id = 0iyO
// module chunks = 72